function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M25.59 0H8.19v5.7L1.52 7.6v-.68a.8.8 0 00.12-.4.82.82 0 10-1.64 0 .8.8 0 00.12.4v2.27l11.16.14h5.12a3.46 3.46 0 016.86 0h5.48V2.68zm-.93.93v1.83H11.28L9.16.95h15.5zM5.79 7.85l2.81-.8 1 .85z"
});

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 19.81,
  cy: 9.78,
  r: 2.72
});

var SvgTow = function SvgTow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 28.72 12.5"
  }, props), _ref, _ref2);
};

export default SvgTow;